var _linearGradient, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Reply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "qTX9tYfAmtQHPbGAM0nPxa",
    x1: 12.686,
    x2: 35.58,
    y1: -566.592,
    y2: -603.841,
    gradientTransform: "matrix(1 0 0 -1 0 -562)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a85d9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qTX9tYfAmtQHPbGAM0nPxa)",
    d: "M42,8H6c-1.105,0-2,0.895-2,2v26c0,1.105,0.895,2,2,2h8v7.998 c0,0.891,1.077,1.337,1.707,0.707L24.412,38H42c1.105,0,2-0.895,2-2V10C44,8.895,43.105,8,42,8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,32c-1.103,0-2-0.897-2-2v-4c0-1.103-0.897-2-2-2h-4v1.875c0,1.104-0.899,2.002-2.005,2.002 c-0.468,0-0.907-0.16-1.271-0.462l-5.894-4.873C12.37,22.16,12.105,21.599,12.105,21s0.265-1.16,0.726-1.541l5.895-4.876 c0.363-0.301,0.803-0.46,1.27-0.46c1.105,0,2.005,0.898,2.005,2.002V18h4c4.411,0,8,3.589,8,8v4c0,1.103-0.897,2-2,2H30z",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30,31.5c-0.827,0-1.5-0.673-1.5-1.5v-4c0-1.379-1.121-2.5-2.5-2.5h-4.5v2.375 c0,0.828-0.675,1.502-1.505,1.502c-0.349,0-0.678-0.119-0.951-0.347l-5.895-4.874c-0.346-0.286-0.544-0.707-0.544-1.156 s0.198-0.87,0.544-1.156l5.895-4.875c0.273-0.227,0.603-0.346,0.951-0.346c0.83,0,1.505,0.674,1.505,1.502V18.5H26 c4.136,0,7.5,3.364,7.5,7.5v4c0,0.827-0.673,1.5-1.5,1.5H30z",
    opacity: 0.07
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26,19h-5v-2.875c0-0.846-0.985-1.31-1.637-0.771l-5.895,4.875c-0.484,0.4-0.484,1.141,0,1.541 l5.895,4.875C20.015,27.185,21,26.721,21,25.875V23h5c1.657,0,3,1.343,3,3v4c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-4 C33,22.134,29.866,19,26,19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Reply);
export default __webpack_public_path__ + "static/media/icons8-reply.5e66a1773de79d670a0762afb9497ca1.svg";
export { ForwardRef as ReactComponent };